import React, { useState, useEffect } from 'react';
import { RadioButton, RadioButtonGroup } from 'carbon-components-react';

const ReceivingResponses: React.FC<Props> = ({ user, updateUserProfile }) => {
  const [response, setResponse] = useState<string>('0');
  const changeHandler = (val: any) => {
    const notification_setting = user.notification_setting;
    const data = {
      notification_setting: {
        ...notification_setting,
        notified_enquiry_final: val === '1',
        notified_enquiry_whenever: val !== '1'
      }
    };
    updateUserProfile(data);
  };

  useEffect(() => {
    const { notified_enquiry_whenever, notified_enquiry_final } =
      user.notification_setting;
    if (notified_enquiry_final && !notified_enquiry_whenever) {
      setResponse('1');
    } else if (!notified_enquiry_final && notified_enquiry_whenever) {
      setResponse('2');
    }
  }, [user.notification_setting]);

  return (
    <div
      id="receivingResponses"
      className="receiving-responses spacing-padding"
    >
      <div className="sub-section-title">Receiving responses</div>
      <div className="radio-button-container">
        <RadioButtonGroup
          name="receivingResponses"
          onChange={(val: string) => {
            changeHandler(val);
          }}
          orientation="vertical"
          valueSelected={response}
        >
          <RadioButton
            id="receivingResponses1"
            labelText="Only send me an email when all responses have been received"
            value="1"
          />
          <RadioButton
            id="receivingResponses2"
            labelText="Send me an email for every response received on my enquiries"
            value="2"
          />
        </RadioButtonGroup>
      </div>
    </div>
  );
};

interface Props {
  user: any;
  updateUserProfile: Function;
}

export default React.memo(ReceivingResponses);
